import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Navbar from '../components/navbar';
import Sidebar from '../components/sidebar';
import { GetCases, getConfig } from '../services/Common';
import Map from './Map';
const Dashboard = () => {
  const [sidebarMenu, setSidebarMenu] = useState(false);
  const [config, setConfig] = useState({});
  const [markers, setMarkers] = useState([]);
  const [activeMarker, setActiveMarker] = useState({});
  const [searchMarker, setSearchMarker] = useState(null);
  const [searchSelection, setSearchSelection] = useState(null);
  const [direction, setDirection] = useState('ltr');
  const [center, setCenter] = useState({
    lat: 25.172675338538472,
    lng: 55.33506405170034,
  });

  const { i18n } = useTranslation();
  useEffect(() => {
    const lang = window.localStorage.getItem('lang')
      ? window.localStorage.getItem('lang')
      : 'en';
    if (lang === 'en') {
      setDirection('ltr');
      i18n.changeLanguage('en');
    } else {
      setDirection('rtl');
      i18n.changeLanguage('ar');
    }
    setSidebarMenu(true);
    getInit();
    getCases();
  }, [i18n]);
  const updateSideMenu = (value) => {
    setSidebarMenu(value);
  };
  const updateCenter = (value) => {
    setActiveMarker(value);
    if (value.gx) setCenter({ lat: +value.gx, lng: +value.gy });
  };
  const updateActiveMarkers = (value) => {
    setActiveMarker(value);
  };
  const updateAppDirection = (value) => {
    setDirection(value);
  };
  const handleLatLngSearch = ({
    lat,
    lng,
    autoOpen = false,
    makaniNumber = '',
  }) => {
    setCenter({ lat, lng });
    setSearchMarker({ lat, lng, makaniNumber });
    setSearchSelection({
      lat,
      lng,
      autoOpen,
      makaniNumber,
      requestId: Date.now(),
    });
  };
  const getInit = () => {
    return getConfig().then((res) => {
      if (res) {
        setConfig(res);
      }
    });
  };
  const getCases = () => {
    return GetCases().then((res) => {
      if (res) {
        setMarkers(res);
      }
    });
  };
  return (
    <div>
      <Navbar
        sideMenu={sidebarMenu}
        appDir={direction}
        dirCallBack={updateAppDirection}
        sideMenuCallback={updateSideMenu}
        onLatLngSearch={handleLatLngSearch}
      />
      <div className='flex pt-16 overflow-hidden bg-gray-50 dark:bg-gray-900'>
        <Sidebar
          sideMenu={sidebarMenu}
          sideMenuCallback={updateSideMenu}
          configInfo={config}
          markersList={markers}
          appDir={direction}
          activeMarker={activeMarker}
          updateCenterData={updateCenter}
        />
        <div
          id='main-content'
          className='relative w-full h-full overflow-y-auto bg-gray-50   dark:bg-gray-900'>
          <main className='bg-gray-50 dark:bg-gray-900'>
            <Map
              locations={markers}
              configInfo={config}
              activeMarker={activeMarker}
              centerValue={center}
              searchMarker={searchMarker}
              searchSelection={searchSelection}
              appDir={direction}
              activeMarkerCallBack={updateActiveMarkers}
              getMarkers={getCases}
            />
          </main>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
